import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Flex } from '@chakra-ui/react'

import Collaborators from 'components/Collaborators'
import subscriptionInfo from 'components/Collaborators/constants'
import { ProviderCollaborator } from 'providers/CollaboratorsProvider'
import { useAuthContext } from 'providers/AuthProvider'
import { useGlobalContext } from 'providers/GlobalProvider'
import { getRoles, collaboratorList } from 'services/api'
import { isSuccessStatus } from 'utils/functions/validations'
import ErrorPage from './ErrorPage'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const CollaboratorsPage = () => {
  const { getUser } = useAuthContext()
  const { idEmpresa, idSuscriptor } = useGlobalContext()
  const [initData, setInitData] = useState<any>()
  const [isError, setIsError] = useState<boolean>(false)
  const titleError: string = 'En estos momentos presentamos inconvenientes en la plataforma,'
  const subtitle: string = 'Por favor intentá nuevamente en unos minutos'
  const location: any = useLocation()
  const subscriptionType = location?.state?.subscriptionType
  const title = '¿A quién puedo asignar como colaborador?'
  const suscriptions = Object.values(subscriptionInfo)
  const selectedSuscription = suscriptions.filter(suscription => suscription.subscriptionType.toLowerCase() === subscriptionType.toLowerCase())
  const data = async () => {
    if (!idSuscriptor) return []
    try {
      const [roles, user, selectedCollaborators] = await Promise.all([getRoles(), getUser(), collaboratorList(idSuscriptor, idEmpresa)])
      if (isSuccessStatus(roles.status) && isSuccessStatus(selectedCollaborators.status)) {
        return { roles: roles.data, user, selectedCollaborators: selectedCollaborators.data }
      }

      return setIsError(true)
    } catch (error) {
      setIsError(true)
      return []
    }
  }

  useEffect(() => {
    data()
      .then(setInitData)
  }, [idSuscriptor])

  return (
    isError ?
      <ErrorPage title={titleError} subtitle={subtitle} /> :
        <ProviderCollaborator initData={{ ...initData }}>
          <GoogleReCaptchaProvider language="es-AR" reCaptchaKey={process.env.GOOGLE_RECAPTCHA_SITE_KEY}>
          <Flex flexDir='row'>
            <Collaborators
              subscriptionInfo={selectedSuscription.length > 0 ? selectedSuscription[0] : suscriptions[0]}
              title={title}
            />
          </Flex >
          </GoogleReCaptchaProvider>
        </ProviderCollaborator>      
  )
}

export default CollaboratorsPage
